import { render, staticRenderFns } from "./MaterialAvatar.vue?vue&type=template&id=1fe667f4&scoped=true&lang=pug&"
import script from "./MaterialAvatar.vue?vue&type=script&lang=js&"
export * from "./MaterialAvatar.vue?vue&type=script&lang=js&"
import style0 from "./MaterialAvatar.vue?vue&type=style&index=0&id=1fe667f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe667f4",
  null
  
)

export default component.exports